export const leadGenFormTitle = {
  BRIO_INAISLE_SFI_BLND: 'Blinds Installation',
  BRIO_INAISLE_SFI_CABR: 'Cabinet Makeover',
  BRIO_INAISLE_SFI_CABINETS: 'Kitchen Cabinet Installation',
  BRIO_INAISLE_SFI_CLOS_ORG: 'Closet Installation',
  BRIO_INAISLE_SFI_FENC: 'Fence Installation',
  BRIO_INAISLE_SFI_SOLARPWR: 'Solar Panel Installation',
  BRIO_INAISLE_SFI_SDOOR: 'Shower Door Installation',
  BRIO_INAISLE_SFI_GAR_ORG: 'Garage Storage Installation',
  BRIO_INAISLE_SFI_WIND: 'Window Installation',
  BRIO_INAISLE_SFI_HVAC: 'HVAC Installation & Replacement',
  BRIO_INAISLE_SFI_BATHLINERS: 'Tub to Shower Conversion',
  BRIO_INAISLE_SFI_GENE: 'Generator Installation',
  BRIO_INAISLE_SFI_SHUT: 'Plantation Shutter Installation',
  'kirsch-custom-window-treatments/51e8e1b61': 'Kirsch Custom Window Treatments',
  'water-treatment/879700ce6': 'Water Treatment Services',
  brio_inaisle_sfi_twht: 'Tankless Water Heater Installation',
  brio_inaisle_sfi_whtr: 'Water Heater Installation',
  dualpath_inaisle_sfi_generators: 'Generator Installation',
  dualpath_inaisle_sfi_windows: 'Window Installation',
  'dreamline-door-installation/44fbb1b75': 'Dreamline Shower Door Installation',
  'plumbing-repair-dp/9f2b4389b': 'Plumbing Repair',
  'water-heater-repair-dp/201c992c0': 'Water Heater Repair'
};